import { useContext } from "react";
import { SocketContext, TeamContext, UserContext } from "../../../context";
import { IPlayer } from "../../../interfaces";
import { DilemmaOwnerAnouncementText, RenderActionDisplay } from "../../molecules";
import { useBoardDisplayView } from "../../../hooks";
import { useTranslation } from "react-i18next";

const ChosenActionFullScreen = () => {
    const { t } = useTranslation();
    const { finishActionCardSocketEvent } = useContext(SocketContext);
    const { game } = useContext(TeamContext);
    const { userData } = useContext(UserContext);
    const dilemmaOwner = game?.players.find((player: IPlayer) => { return game.gameInfo.currentPlayerEmail === player.email });
    const dilemmaOwnerNickname = dilemmaOwner?.nickname || "";
    const isTheUserDilemaOwner = userData?.email === game?.gameInfo.currentPlayerEmail;
    const [challengeCard ] = useBoardDisplayView();

    const comfirmActionCard = () => {
        finishActionCardSocketEvent();
    }

    return (
        <div className="chosen_dilemma_full_screen_wrapper center_horizontally_and_vertically full_screen_vw_vh">
            <div className="chosen_dilemma_full_screen">
                <DilemmaOwnerAnouncementText upperText={dilemmaOwnerNickname + ' ' + t("isTheDilemmaOwnerText")} componentStyle="dilemma" />
                <div className="chosen_action_full_screen_card_wrapper center_horizontally">
                    <RenderActionDisplay challengeCard={challengeCard} isTheUserDilemaOwner={isTheUserDilemaOwner} comfirmActionCardParent={() => comfirmActionCard()} />
                </div> 
            </div>
        </div>
    )
}

export default ChosenActionFullScreen;